module.exports = __webpack_public_path__ + "static/media/Parkwoods_DCCR.dee33575.pdf";